export const SET_SPLASH_SCREEN_VISIBLE = "SET_SPLASH_SCREEN_VISIBLE";
